/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from '@mui/material';
import {
  CreateAcceptanceApiRequest,
  CreateApprovalApiRequest,
  // CreatePersonalPropertyApiRequest,
  // CreateRequestInsurancePlacementRequest,
  // CreateResetButtonStatusApiRequest,
  // CreateSendOfferPackageRequest,
  CreateTitleDocumentApiRequest
} from './buyoutApiRequestFactory';
import {
  CreateAcceptanceFormFields,
  CreateApprovalFormFields,
  CreateTitleFormFields
} from './buyoutFormFields';
import { Permissions } from 'modules/layout/permissions';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_HOMESALE_TITLE_DOCUMENT_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  getBuyout,
  getHomesaleInfo,
  postBuyout,
  updateBuyout,
  updateHomesaleTitleDocument
} from 'modules/authorizations/store/actions/homesale.actions.js';
import { hasPermission } from 'modules/layout/permissionService';
import { showToast } from 'modules/layout/layout.actions';
import { useBuyoutHandler } from './buyoutApiHandler.js';
import EditableCard from 'modules/common/editableCard.component';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const Buyout = props => {
  const { homesale, titleReps, homesaleId, isReadOnly, enumerations, vendors, isLoadingModal, fileId } = props;
  const canEditTitle = hasPermission(Permissions.File.Homesale.Title.Edit);

  const [isLoading, setIsLoading] = useState(false);
  const buyoutHandler = useBuyoutHandler(props);


  const checkAndCreateBuyout = async () => {
    if (!homesaleId) return false;

    if (!homesale?.homesaleBuyoutId) {
      const created = await buyoutHandler.handleCreateHomesaleBuyout({ ...homesale, homesaleId: homesaleId });
      if (!created) return false;
    }

    const latestBuyoutResp = await props.getBuyout(homesaleId);
    return latestBuyoutResp?.response ?? homesale ?? {};
  };

  // TRC Contract (approval) and Acquisition (acceptance) are separate cards that each save their own fields of the
  // same buyout record.
  const handleApprovalOrAcceptanceSubmit = async (values, createRequest) => {
    setIsLoading(true);
    const buyoutValues = await checkAndCreateBuyout();
    if (!buyoutValues) {
      setIsLoading(false);
      return false;
    }
    const request = createRequest(buyoutValues, values, homesaleId);

    const resp = await buyoutHandler.handleUpdateHomesaleBuyout(request);
    await props.getHomesaleInfo(fileId);
    setIsLoading(false);
    return resp;
  };

  // Local Title edits are stored with Morreale's title document, not the buyout record. Morreale's next push replaces them.
  const handleTitleDocumentSubmit = async (tab, values) => {
    setIsLoading(true);
    const resp = await props.updateHomesaleTitleDocument(fileId, CreateTitleDocumentApiRequest(homesale, values));
    if (resp.type === UPDATE_HOMESALE_TITLE_DOCUMENT_FAILURE) {
      props.showToast('Failed to update title info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    }
    await props.getHomesaleInfo(fileId);
    setIsLoading(false);
    return true;
  };


  let approvalFormFields = CreateApprovalFormFields(homesale);
  let acceptanceFormFields = CreateAcceptanceFormFields(homesale, enumerations);
  let titleFormFields = CreateTitleFormFields(homesale, titleReps, vendors, enumerations);

  return (
    <>
      <Box sx={{ paddingTop: '10px' }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} xl={8}>
            <Box sx={{ mb: 1 }}>
              <EditableCard
                tabs={approvalFormFields.tabs}
                summaries={approvalFormFields.summaries}
                updateFields={(tab, values) => handleApprovalOrAcceptanceSubmit(values, CreateApprovalApiRequest)}
                isLoading={isLoading}
                numColumns={5}
                hideEdit={isReadOnly || isLoadingModal}
              />
            </Box>
            <Box sx={{ mb: 1 }}>
              <EditableCard
                tabs={acceptanceFormFields.tabs}
                summaries={acceptanceFormFields.summaries}
                updateFields={(tab, values) => handleApprovalOrAcceptanceSubmit(values, CreateAcceptanceApiRequest)}
                isLoading={isLoading}
                numColumns={5}
                hideEdit={isReadOnly || isLoadingModal}
              />
            </Box>
            {homesale?.saleType !== 1 ? (
              <Box sx={{ mb: 1 }}>
                <EditableCard
                  tabs={titleFormFields.tabs}
                  summaries={titleFormFields.summaries}
                  updateFields={handleTitleDocumentSubmit}
                  isLoading={isLoading}
                  numColumns={5}
                  hideEdit={isReadOnly || !canEditTitle || isLoadingModal}
                  topHintText="Title data is provided by Morreale via API. Morreale's updates replace any edits made here."
                />
              </Box>
            ) : (
              <div />
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

Buyout.propTypes = {
  homesale: PropTypes.object.isRequired,
  titleReps: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired
};

export default compose(
  connect(null, {
    updateBuyout,
    postBuyout,
    getBuyout,
    showToast,
    getHomesaleInfo,
    updateHomesaleTitleDocument
  })
)(Buyout);
